import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuroraTextComponent } from '@shared/components/aurora-text/aurora-text.component';
import { RouterLink } from '@angular/router';
import { PermissionService } from '@shared/services/permission.service';
import { RouteNames } from '../../route-names';
import { TuiButton } from '@taiga-ui/core';

@Component({
  selector: 'app-home',
  imports: [AuroraTextComponent, RouterLink, TuiButton],
  templateUrl: './home.component.html',
  styleUrl: './home.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {
  protected readonly RouterLink = RouterLink;
  protected readonly RouteNames = RouteNames;

  constructor(private readonly permissionService: PermissionService) {}
}
